class CartDrawerSkeleton {
  constructor() {
    this.drawer = document.querySelector("#cart-drawer");
    this.cartDrawerAnimation;
    if (!this.drawer) return;
    this.init();
  }
  init() {
    this.cartDrawerAnimation = this.drawer.getAttribute("skeleton_animation");

    if (this.cartDrawerAnimation && this.cartDrawerAnimation === "true") {
      this.setupEventListeners();
    }
  }
  setupEventListeners() {
    if (this._listenersSet) return; // Prevent duplicate bindings
    this._listenersSet = true;
    document.addEventListener("line-item:will-change", (e) => {
      const item = e.target;
      this.animateItem(item);
      this.skeletonFooter();
      this.disableCheckoutButton();
    });
  }
  animateItem(item) {
    if (!item) return;
    item.classList.remove("line-item");
    const wrapper = document.createElement("div");
    wrapper.classList.add("line-item", "line-item-opacity", "tw-h-full");
    wrapper.innerHTML = item.innerHTML;
    item.innerHTML = ""; // Clear old content
    item.appendChild(wrapper);
    item.appendChild(this.loadingCircle());
  }
  skeletonFooter() {
    const zwischensumme = this.drawer.querySelector(".zwischensumme");
    const percentage = this.drawer.querySelector("total-savings .percentage");
    const amount = this.drawer.querySelector("total-savings .amount");

    if (zwischensumme) {
      zwischensumme.outerHTML = `<div class="cart-skeleton-price cart-skeleton" style="width:${zwischensumme.offsetWidth}px; height:${zwischensumme.offsetHeight}px;"></div>`;
    }
    if (percentage && amount) {
      percentage.outerHTML = `<div class="cart-skeleton-percentage cart-skeleton" style="width:${percentage.offsetWidth}px; height:${percentage.offsetHeight}px;"></div>`;
      amount.outerHTML = `<div class="cart-skeleton-amount cart-skeleton" style="width:${amount.offsetWidth}px; height:${amount.offsetHeight}px;"></div>`;
    }
  }
  disableCheckoutButton() {
    const checkoutButton = this.drawer.querySelector(
      "form[action='/cart'] button[type='submit']"
    );
    if (checkoutButton) checkoutButton.disabled = true;
  }

  loadingCircle() {
    const div = document.createElement("div");
    div.classList.add("loading-wrapper");
    div.innerHTML = `
      <svg class="loader" xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none"><g clip-path="url(#clip0)">
          <path d="M23.5156 11.7578C23.5156 18.2515 18.2515 23.5156 11.7578 23.5156C5.26414 23.5156 0 18.2515 0 11.7578C0 5.26414 5.26414 0 11.7578 0C18.2515 0 23.5156 5.26414 23.5156 11.7578ZM21.162 11.7571C21.162 6.56288 16.9514 2.35291 11.7578 2.35291C6.56422 2.35291 2.35291 6.56355 2.35291 11.7571C2.35291 16.9507 6.56355 21.1614 11.7571 21.1614C16.9507 21.1614 21.1614 16.9507 21.1614 11.7571H21.162Z" fill="#E8ECD8"/>
          <path d="M10.5614 21.0903C6.44752 20.5696 3.16272 17.391 2.48077 13.3295C2.37999 12.7315 1.83241 12.3136 1.22839 12.368C0.530315 12.4312 0.048581 13.054 0.160784 13.7219C1.01339 18.7999 5.11989 22.7734 10.2638 23.4244C11.0089 23.5185 11.6532 22.9024 11.5773 22.1552C11.5195 21.5889 11.1003 21.1575 10.5607 21.0897L10.5614 21.0903Z" fill="#819A31"/></g><defs><clipPath id="clip0"><rect width="24" height="24" fill="white"/></clipPath></defs>
      </svg>`;
    return div;
  }
}

document.addEventListener("DOMContentLoaded", () => {
  window.cartDrawerSkeleton = new CartDrawerSkeleton();
});
